// removed by extract-text-webpack-plugin
module.exports = {"content":"Duration__content___103Fe"};